import React, { forwardRef } from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import CustomIcons from "./customIcons/CustomIcons";
import { useNotification } from "../../hooks/useNotification";

const OptionButton = forwardRef(({ icon, path, onClick }, ref) => {
  const navigate = useNavigate();
  // if onClick is null then () => navigate(path)
  // if onClick is not null then onClick
  const onClickFunction = onClick ? onClick : () => navigate(path);
  return (
    <Button
      ref={ref}
      type="text"
      icon={<div style={{ display: "flex", alignItems: "center" }}>{icon}</div>}
      onClick={onClickFunction}
      style={{
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "10px",
        paddingBottom: "10px",
      }}
    />
  );
});

const HeaderOptions = () => {
  const { toggleNotificationPop, notificationButtonRef } = useNotification();
  const handleNotificationButtonClick = (e) => {
    e.stopPropagation();
    toggleNotificationPop();
  };
  return (
    <div
      style={{
        display: "flex",
        gap: "8px",
      }}
    >
      <OptionButton
        icon={<CustomIcons icon="settings" />}
        path="/settings"
        style={{ alignItems: "center", backgroundColor: "blue" }}
      />
      <OptionButton
        ref={notificationButtonRef}
        icon={<CustomIcons icon="alert" />}
        onClick={handleNotificationButtonClick}
        style={{ alignItems: "center", backgroundColor: "blue" }}
      />
      <OptionButton
        icon={<CustomIcons icon="support" />}
        style={{ alignItems: "center", backgroundColor: "blue" }}
      />
    </div>
  );
};
export default HeaderOptions;
